import get from 'lodash/get';
import merge from 'lodash/merge';
import identityConfig from '../../../config/identity';
import { figureOutPriorityTag } from '../../../utils/ad_util';

export default function datalayer(
  context,
  location,
  firstLoad,
  unsanitizedURL
) {
  const siteConfig = identityConfig;

  if (siteConfig === undefined) {
    return '';
  }

  console.log('--- Showing for: ', '\n', process.env); // eslint-disable-line
  console.log('Jenv: '+process.env.NODE_ENV); // eslint-disable-line

  let adobeLibraryString =
    '<script src="//assets.adobedtm.com/launch-ENf6f754d17779412f8d246f49c783f295.min.js" async></script>';
  if (process.env.NODE_ENV === 'development' || process.env.STAGE === 'true') {
    adobeLibraryString =
      '<script src="//assets.adobedtm.com/launch-EN872a0ecc7ca64ebbb6c4da2f621e0736-development.min.js" async></script>';
  }

  const {
    postData,
    tagPageData,
    categoryPageData,
    authorPageData,
    searchPageData,
    staticPageData,
    mostCreativePeoplePageData,
    personPageData,
    statusCode,
    ibdPageData,
    companyPageData,
    micYearPageData,
    micSectorPageData,
    videoPageData,
    productPageData,
    playlistAllFeedData,
    type,
    config
  } = context;

  const getDaysSincePubdate = date =>
    Math.round((new Date().getTime() - new Date(date)) / (24 * 60 * 60 * 1000));
  const defaultDestination = get(config, 'navHistory[0]', 'unknown');
  let userAB = get(config, 'abgroup', '0');

  if (!userAB) {
    userAB = undefined;
  }

  let dataLayerMapping = {
    page: {
      category: {
        primaryCategory: 'FastCompany',
        subCategory1: '',
        subCategory2: ''
      },
      pageInfo: {
        pageName: 'fastcompany:missing',
        publisher: 'fast company',
        author: 'fast company',
        authorStatus: 'staff',
        editorName: 'FC Editor',
        pageID: 'fc-default-id',
        destinationURL: `https://www.fastcompany.com/?untracked=${defaultDestination}`,
        server: 'fc-node',
        urlText: '',
        adPath: '',
        infiniteScrollIndex: 1,
        pubdate: '1995-11-01',
        daysSincePubdate: -1,
        type: '',
        contentType: '',
        editTags: '',
        referringURL: ''
      }
    },
    user: [
      {
        profile: [
          {
            address: {
              stateProvince: '',
              postalCode: ''
            },
            attributes: {
              isLoggedIn: get(config, 'auth.loggedIn', ''),
              bombora: {
                security: {
                  CompanyRevenue: ['Analytics', 'Personalization'],
                  CompanySize: [
                    'Analytics',
                    'Recommendations',
                    'Personalization'
                  ],
                  CompanyDomain: [
                    'Analytics',
                    'Recommendations',
                    'Personalization'
                  ],
                  CompanyInstall: ['Analytics', 'Personalization'],
                  FunctionalArea: [
                    'Analytics',
                    'Recommendations',
                    'Personalization'
                  ],
                  Profession: [
                    'Analytics',
                    'Recommendations',
                    'Personalization'
                  ],
                  Seniority: [
                    'Analytics',
                    'Recommendations',
                    'Personalization'
                  ],
                  DecisionMaker: 'Personalization',
                  Education: 'Analytics'
                }
              }
            },
            profileInfo: {
              profileID: ''
            }
          }
        ],
        segment: {
          abGroup: userAB
        }
      }
    ]
  };

  const typeLookup = {
    homepage() {
      return merge({}, dataLayerMapping, {
        page: {
          pageInfo: {
            pageName: `Homepage`,
            destinationURL: `https://www.fastcompany.com`,
            adPath: '/4160/mv.fc/homepage/homepage'
          },
          category: {
            primaryCategory: `homepage`,
            subCategory1: `homepage`,
            subCategory2: `homepage`
          }
        }
      });
    },
    post() {
      const pageName = postData.title;
      const destinationURL = postData.link;
      const tags = get(postData, 'tags');
      const eyeBrowText = figureOutPriorityTag(tags);

      let author = '';
      if (postData.author && postData.author.name !== '') {
        author = postData.author.name;
      }

      let primaryCategory = '';
      if (
        postData.categories &&
        postData.categories.length > 0 &&
        postData.categories[0] !== undefined
      ) {
        primaryCategory = postData.categories[0].name;
      }

      let subCategory = '';
      if (
        postData.categories &&
        postData.categories.length > 0 &&
        postData.categories[1] !== undefined
      ) {
        subCategory = postData.categories[1].name;
      } else {
        subCategory = primaryCategory;
      }

      const subSubCategory =
        get(eyeBrowText, 'slug') !== '' ? get(eyeBrowText, 'slug') : 'misc';

      let tagString = '';
      tagString = postData.tags.map(tag => tag.name).join(',');

      const pubdate = postData.omnitureDate ? `${postData.omnitureDate}` : '';

      let pageType = 'article';
      if (get(postData, 'posterSlideshow.length')) {
        pageType = 'slideshow';
      } else if (
        get(postData, 'hasVideoPoster') === true ||
        get(postData, 'posterVideo.feedId')
      ) {
        pageType = 'video';
      }

      const urlText = postData.slug.replace(/-/g, ' ');

      return merge({}, dataLayerMapping, {
        page: {
          pageInfo: {
            pageName,
            pageID: `fc${postData.id}`,
            destinationURL: `${destinationURL}`,
            referringURL: '',
            author,
            editorName: 'FC Editor',
            pubdate,
            daysSincePubdate: getDaysSincePubdate(pubdate),
            type: pageType,
            publisher: 'fast company',
            server: 'fc-node',
            urlText,
            editTags: tagString,
            infiniteScrollIndex: 1
          },
          category: {
            primaryCategory: `${primaryCategory}`,
            subCategory1: `${subCategory}`,
            subCategory2: `${subSubCategory}`
          }
        }
      });
    },
    page() {
      return merge({}, dataLayerMapping, {
        page: {
          pageInfo: {
            pageName: `${get(staticPageData, 'slug')} | page`,
            destinationURL: `${get(siteConfig, 'url')}/${get(
              staticPageData,
              'slug'
            )}`,
            type: 'page'
          }
        }
      });
    },
    category() {
      const category = get(categoryPageData, 'slug', 'news');
      return merge({}, dataLayerMapping, {
        page: {
          pageInfo: {
            pageName: `${categoryPageData.name} | ${categoryPageData.taxonomy}`,
            destinationURL: `${get(siteConfig, 'url')}/${category}`,
            type: 'category page',
            contentType: 'lander',
            editTags: `${category}`,
            pageID: `fc-category-${category}-${categoryPageData.id}`
          },
          category: {
            primaryCategory: `${category}`,
            subCategory1: `${category}`,
            subCategory2: `${category}`
          }
        }
      });
    },
    tag() {
      let tag = '';
      tag = get(tagPageData, 'slug', 'tag');
      return merge({}, dataLayerMapping, {
        page: {
          pageInfo: {
            pageName: `${tag} | tag`,
            destinationURL: `${get(siteConfig, 'url')}/section/${tag}`,
            type: 'section',
            contentType: 'collection',
            editTags: `${tag}`,
            pageID: `fc-tag-${tag}-${tagPageData.id}`
          },
          category: {
            primaryCategory: `${tag}`,
            subCategory1: `${tag}`,
            subCategory2: `${tag}`
          }
        }
      });
    },
    author() {
      const authorSlug = get(authorPageData, 'slug', 'fastcompany-staff');
      const authorName = get(authorPageData, 'name', 'Fastcompany Staff');

      return merge({}, dataLayerMapping, {
        page: {
          pageInfo: {
            pageName: `${authorName} | author`,
            author: authorName,
            destinationURL: `${get(siteConfig, 'url')}/user/${authorSlug}`,
            adPath: `/4160/mv.fc/author/author`,
            pageID: `fc-author-${authorPageData.id}`,
            contentType: 'lander',
            type: 'author page'
          },
          category: {
            primaryCategory: 'author',
            subCategory1: authorName,
            subCategory2: authorName
          }
        }
      });
    },
    videoPage() {
      const currentVideoData = get(videoPageData, 'data.playlist[0]', null);
      if (!currentVideoData) {
        return {};
      }

      // const videoTag = get(currentVideoData, 'category');
      const postID = get(currentVideoData, 'id');

      let tagString = '';
      tagString = currentVideoData.tags.map(tag => tag.name).join(',');

      // Extend original omniture variable
      return merge({}, dataLayerMapping, {
        page: {
          pageInfo: {
            pageName: get(currentVideoData, 'title'),
            author: `fast company video`,
            editorName: 'FC Video',
            destinationURL: get(currentVideoData, 'link'),
            pubdate: get(currentVideoData, 'omnitureDate'),
            daysSincePubdate: getDaysSincePubdate(
              get(currentVideoData, 'omnitureDate')
            ),
            contentType: 'video',
            type: 'video_page',
            editTags: tagString,
            pageID: `fc-jw${postID}`
          },
          category: {
            primaryCategory: 'video',
            subCategory1: currentVideoData.series,
            subCategory2: currentVideoData.category.toLowerCase()
          }
        }
      });
    },
    companyPage() {
      const companyName = get(companyPageData, 'data.tags[0].name', '');
      const companySlug = get(companyPageData, 'data.tags[0].slug', '');
      const companyId = get(companyPageData, 'data.tags[0].id', '');

      return merge({}, dataLayerMapping, {
        page: {
          pageInfo: {
            destinationURL: `${get(siteConfig, 'url')}/company/${companySlug}`,
            pageName: `${companyName} | company`,
            pageID: `fc-company-${companyId}`,
            contentType: 'company profile',
            type: 'company page',
            pubdate: '2019-02-20',
            daysSincePubdate: getDaysSincePubdate('2019-02-20'),
            editTags: `${companyName},mic,most innovative companies`
          },
          category: {
            primaryCategory: 'award',
            subCategory1: 'most innovative companies',
            subCategory2: 'company'
          }
        }
      });
    },
    mostCreativePeoplePage() {
      const year = get(mostCreativePeoplePageData, 'year', '');

      return merge({}, dataLayerMapping, {
        page: {
          pageInfo: {
            pageName: year ? `mcp ${year} | lander` : `mcp default | lander`,
            destinationURL: year
              ? `${get(siteConfig, 'url')}/most-creative-people/${year}`
              : `${get(siteConfig, 'url')}/most-creative-people`,
            editTags: `${year},mcp,most creative people`,
            contentType: 'lander',
            type: 'mcp page',
            pageID: `fc-mcp-${year}`
          },
          category: {
            primaryCategory: 'award',
            subCategory1: 'most creative people',
            subCategory2: 'year'
          }
        }
      });
    },
    personPage() {
      const personSlug = get(personPageData, 'data.rows[0].url', '');
      const personName = `${get(
        personPageData,
        'data.rows[0].first_name',
        ''
      )} ${get(personPageData, 'data.rows[0].last_name', '')}`;
      const personCompanies = get(personPageData, 'data.rows[0].companies', '');
      const personId = get(personPageData, 'data.rows[0].id', '');

      let tagString = '';
      tagString = personCompanies.map(company => company.name).join(',');

      return merge({}, dataLayerMapping, {
        page: {
          pageInfo: {
            pageName: `${personName} | person`,
            contentType: 'profile',
            destinationURL: `${get(siteConfig, 'url')}/person/${personSlug}`,
            type: 'person',
            editTags: `${personName},${tagString},mcp,most creative people`,
            pageID: `fc-person-${personId}`
          },
          category: {
            primaryCategory: 'awards',
            subCategory1: 'most creative people',
            subCategory2: 'person'
          }
        }
      });
    },
    productPage() {
      const productId = get(productPageData, 'data.rows[0].id');
      const productName = get(productPageData, 'data.rows[0].name');
      const productSlug = get(productPageData, 'data.rows[0].url');
      return merge({}, dataLayerMapping, {
        page: {
          pageInfo: {
            contentType: 'product',
            type: 'product',
            pageName: `${productName} | product`,
            destinationURL: `${get(siteConfig, 'url')}/product/${productSlug}`,
            pageID: `fc-product-${productId}`,
            editTags: `${productName},ibd,innovation by design`
          },
          category: {
            primaryCategory: 'awards',
            subCategory1: 'innovation by design',
            subCategory2: 'product'
          }
        }
      });
    },
    micYearPage() {
      const year = get(micYearPageData, 'year', '');

      return merge({}, dataLayerMapping, {
        page: {
          pageInfo: {
            pageName: year ? `mic ${year} | lander` : `mic default | lander`,
            destinationURL: year
              ? `${get(siteConfig, 'url')}/most-innovative-companies/${year}`
              : `${get(siteConfig, 'url')}/most-innovative-companies`,
            editTags: `${year},mic,most innovative companies`,
            contentType: 'lander',
            type: 'mic page',
            pageID: `fc-mic-${year}`
          },
          category: {
            primaryCategory: 'award',
            subCategory1: 'most innovative companies',
            subCategory2: 'year'
          }
        }
      });
    },
    micSectorPage() {
      const year = get(micSectorPageData, 'year', '');
      const sector = get(micSectorPageData, 'sector', '');

      return merge({}, dataLayerMapping, {
        page: {
          pageInfo: {
            pageName: `Most Innovative Companies ${year} ${sector}`,
            destinationURL: `${get(
              siteConfig,
              'url'
            )}/most-innovative-companies/${year}/${sector}`,
            editTags: `${sector},${year},mic,most innovative companies`,
            contentType: 'lander',
            type: 'mic sector page',
            pageID: `fc-mic-${sector}`
          },
          category: {
            primaryCategory: 'award',
            subCategory1: 'most innovative companies',
            subCategory2: 'sector'
          }
        }
      });
    },
    ibdPage() {
      // i.e. http://fastcompany.local:8880/innovation-by-design/2018
      const year = get(ibdPageData, 'year', '');
      return merge({}, dataLayerMapping, {
        page: {
          pageInfo: {
            pageName: year ? `ibd ${year} | lander` : `ibd default | lander`,
            destinationURL: year
              ? `${get(siteConfig, 'url')}/innovation-by-design/${year}`
              : `${get(siteConfig, 'url')}/innovation-by-design`,
            editTags: `${year},ibd,innovation by design`,
            pageID: `fc-ibd-${year}`,
            type: 'ibd year page',
            contentType: 'lander'
          },
          category: {
            primaryCategory: 'awards',
            subCategory1: 'innovation by design',
            subCategory2: 'lander'
          }
        }
      });
    },
    search() {
      const searchQuery = get(unsanitizedURL.split('?searchkey='), '[1]', '');
      const searchAdZone = get(searchPageData, 'ads.model.adzone', '');

      return merge({}, dataLayerMapping, {
        page: {
          pageInfo: {
            adPath: `/4160/mv.fc/${searchAdZone}`,
            pageName: `${searchQuery} | search`,
            destinationURL: `${get(siteConfig, 'url')}/search`,
            pageID: `fc-search-${searchQuery}`,
            editTags: `${searchQuery},search`,
            type: 'search page',
            contentType: 'lander'
          },
          category: {
            primaryCategory: 'search',
            subCategory1: searchQuery,
            subCategory2: 'lander'
          }
        }
      });
    },
    videoPlaylistPage() {
      // i.e. http://fastcompany.local:8880/videos/playlist/trending/jVdHZUiT/1
      const feedid = get(playlistAllFeedData, 'data.feedid');
      const name = get(playlistAllFeedData, 'data.kind').toLowerCase();
      const slug = get(playlistAllFeedData, 'data.slug');
      const adzone = get(playlistAllFeedData, 'ads.model.adzone', '');

      return merge({}, dataLayerMapping, {
        page: {
          pageInfo: {
            adPath: `/4160/mv.fc/${adzone}`,
            pageID: `fc-video-playlist-${feedid}`,
            pageName: `${name} | video playlist`,
            destinationURL: `https://www.fastcompany.com/videos/playlist/${slug}/${feedid}`,
            type: 'video playlist',
            contentType: 'lander'
          },
          category: {
            primaryCategory: 'video',
            subCategory1: name,
            subCategory2: 'playlist'
          }
        }
      });
    },
    videoIndexPage() {
      return merge({}, dataLayerMapping, {
        page: {
          pageInfo: {
            adPath: '/4160/mv.fc/video/video',
            pageID: `fc-video-lander`,
            pageName: `Video Landing Page`,
            destinationURL: `${get(siteConfig, 'url')}/videos`,
            type: 'video page',
            contentType: 'lander'
          },
          category: {
            primaryCategory: 'video',
            subCategory1: 'video',
            subCategory2: 'lander'
          }
        }
      });
    },
    staticPage() {
      if (unsanitizedURL.includes('/newsletters')) {
        // Newsletters Lander | ../newsletters
        return merge({}, dataLayerMapping, {
          page: {
            pageInfo: {
              pageID: `fc-newsletter-lander`,
              pageName: `Newsletters Landing Page`,
              destinationURL: `${get(siteConfig, 'url')}/newsletters`,
              type: 'newsletter page',
              contentType: 'lander'
            },
            category: {
              primaryCategory: 'newsletter',
              subCategory1: 'newsletter',
              subCategory2: 'lander'
            }
          }
        });
      }
      return merge({}, dataLayerMapping);
    },
    sitemapIndexPage() {
      return merge({}, dataLayerMapping, {
        page: {
          pageInfo: {
            pageID: `fc-sitemap-lander`,
            pageName: `Site Map Index Page`,
            destinationURL: `${get(siteConfig, 'url')}/sitemap`,
            type: 'sitemap page',
            contentType: 'lander'
          },
          category: {
            primaryCategory: 'sitemap',
            subCategory1: 'sitemap',
            subCategory2: 'lander'
          }
        }
      });
    },
    sitemapPostPage() {
      return merge({}, dataLayerMapping, {
        page: {
          pageInfo: {
            pageID: `fc-sitemap-post`,
            pageName: `Site Map Post Page`,
            destinationURL: `${get(siteConfig, 'url')}/sitemap`,
            type: 'sitemap post page',
            contentType: 'lander'
          },
          category: {
            primaryCategory: 'sitemap',
            subCategory1: 'sitemap',
            subCategory2: 'lander'
          }
        }
      });
    }
  };

  if (typeLookup[type]) {
    dataLayerMapping = typeLookup[type]();
  }

  // Handle 404 pages
  if (statusCode && statusCode === 404) {
    dataLayerMapping = merge({}, dataLayerMapping, {
      page: {
        pageInfo: {
          pageName: `status-${statusCode}`,
          type: 'status',
          destinationURL: defaultDestination,
          contentType: 'lander',
          editTags: `${statusCode}`,
          pageID: `fc-${statusCode}`,
          adPath: ''
        },
        category: {
          primaryCategory: '404',
          subCategory1: '404',
          subCategory2: '404'
        }
      }
    });
  }

  return `<script>
      window.digitalData = {
        page: ${JSON.stringify(get(dataLayerMapping, 'page', ''))},
        user: ${JSON.stringify(get(dataLayerMapping, 'user', ''))}
      };
    </script>
    ${adobeLibraryString}
    <!--<script src="//assets.adobedtm.com/launch-ENf6f754d17779412f8d246f49c783f295.min.js" async></script>->
    <!--<script src="//assets.adobedtm.com/launch-ENae3b16f9157a49eda0902dde98a29706-development.min.js" async></script>-->
  `;
}
